module.exports = __webpack_public_path__ + "media/44.d4e5fc34.mp3";